import { defineMessages } from 'react-intl';

export const joinWorkspaceDialogMessages = defineMessages({
  title: {
    defaultMessage: "You've been invited to join <br></br>{teamName}",
    id: 'qXxZqj5WyJ',
    description: 'Heading of the in-app dialog confirming a workspace invitation',
  },
  inviteSentTo: {
    defaultMessage: 'Invite sent to {email}',
    id: 'mdOyew1GKG',
    description: 'Shows which email address the workspace invitation was sent to',
  },
  ignoreInvite: {
    defaultMessage: 'Ignore invite',
    id: 'KPtsAEQnKF',
    description: 'Button that dismisses the workspace invitation dialog',
  },
  joinTeam: {
    defaultMessage: 'Join team',
    id: 'BfcgXmUwXa',
    description: 'Button that accepts the workspace invitation',
  },
});
